import './SpecialEffectsSelectPanel.less';
import classNames from 'classnames';
import { Card } from 'antd';
import type { FontSpecialEffectProps } from "../constants";
import FontSpecialEffectItem from '@/components/WorkSpace/components/FontSpecialEffectItem';


interface IProps {
    fontSpecialEffectsConfig: FontSpecialEffectProps[],
    selectedIndex: number,
    onSelect: (value?: any) => void;
}


function SpecialEffectsSelectPanel(props: IProps) {
    const { selectedIndex, fontSpecialEffectsConfig, onSelect } = props;

    return (
        <Card >
            <div className="special-effects-panel">
                {fontSpecialEffectsConfig.map((item, index) => {
                    const selected = index === selectedIndex
                    const cs = classNames('font-special-effects-item', { 'font-special-effects-item-selected': selected })
                    return (
                        <FontSpecialEffectItem
                            key={index}
                            value={index}
                            className={cs}
                            selected={selected}
                            fontSizeProp={32}
                            {...item}
                            onSelect={onSelect} />
                    )
                })
                }
            </div>
        </Card>
    )
}
export default SpecialEffectsSelectPanel;